import React from 'react';
import classes from "./BlacklistConfirmationModal.module.css";
import Spinner from './Spinner';

const UnsubConfirmationModal = ({setModal, msisdn ,unsubMsisdn , unsubLoading }) => {
  return (
      <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/warning.png"
                        alt="warning"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>Unsub '{msisdn}'
                    </p>
                    <p className={classes.text}>Are you sure you want to unsub this number?</p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button"
                    disabled={unsubLoading}
                    onClick={unsubMsisdn}
                    >
                        {unsubLoading ? <Spinner /> : "Yes"}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        disabled={unsubLoading}
                        onClick={()=>setModal(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
  )
}

export default UnsubConfirmationModal